import { useRoute, useWorkflowStep } from "@bcm-dev/bcms-vite";
import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import { getDefault, getWorkflowSteps } from "components/workflows/BalanceTransferWorkflow";
import React from "react";
import DisputeAmountView from "./components/DisputeAmountView";
import DisputeContactView from "./components/DisputeContactView";
import DisputeReasonView from "./components/DisputeReasonView";
import DisputeServiceReasonView from "./components/DisputeServiceReasonView";
import DisputeSubmittedView from "./components/DisputeSubmittedView";
import DisputeTransactionView from "./components/DisputeTransactionView";
import ReviewingDisputeView from "./components/ReviewingDisputeView";
import "./styles.css";

/**
 * @function DisputeTransactionPage
 * @return {React.Component}
 * @exported true
 * @description This is container fo the Dispute Transaction workflow. 
 * @example
 * <DisputeTransactionPage />
 */
export default function DisputeTransactionPage(props){
  const navigate = useRoute();
  const workflowStep = useWorkflowStep(getDefault, getWorkflowSteps);
  const workflowStepState = workflowStep.getStepState;
  const viewType = props.view.type;

  const back = evt => {
    // If this is the first page in the Dispute Transaction workflow,
    // go back to the transaction details page.
    if(viewType === DisputeTransactionView || viewType === ReviewingDisputeView) {
      navigate(-1);
    // Else go back to the previous Dispute Transaction page.
    } else {
      switch(props.view.type) {
        case DisputeReasonView:
          workflowStep.workflow.goStep(0, { ...workflowStepState });
          break;
        case DisputeSubmittedView:
          workflowStep.workflow.goStep(2, { ...workflowStepState });
          break;
        case DisputeServiceReasonView:
          workflowStep.workflow.goStep(2, { ...workflowStepState });
          break;
        case DisputeContactView:
          workflowStep.workflow.goStep(0, { ...workflowStepState });
          break;
        default:
          // Handle "Services or experiences" chosen condition since that is a page on step 7
          // in the workflow component, which is the last step. It is out of order since this
          // is a different scenario in the workflow, 
          // but all other steps are reused and remain the same.
          if(workflowStepState.data) {
            if(viewType === DisputeAmountView && workflowStepState.data.workflowType === "services") {
              workflowStepState.data.workflowType = undefined;
              workflowStep.workflow.goStep(7, { ...workflowStepState });
              break;
            }
          }

          workflowStep.workflow.prevStep();
          break;
      }
    }
  }
  return(
    <MainContentContainer className="dispute-transaction-page">
      <MainContentHeader text="Dispute Transaction" onClick={ back } />
      {/* <Outlet />*/}
      { props.view }
      {/*<DisputeServiceReasonView />
      <DisputeMerchandiseReasonView />
      <DisputeTransactionReasonView />
      <DisputeItemServiceView />
      <DisputeAmountView />
      <DisputeContactResolveView />
      <ReviewingDisputeView />
      <DisputeDissatisfiedConfirmView />*/}
    </MainContentContainer>
  );
}